import React, { useState } from 'react';
import Axios from 'axios';
import real_l from "./real_logo.png";
import { Host } from '../../App';
import './Pivot.css';
import './DynamicTable_Tooltip.css';

function DynamicTable({ postList, section }) {
  var token = (window.localStorage.getItem("acessToken"));
  var User = JSON.parse(window.localStorage.getItem("Name"));

  const nowDate = new Date();
  const formattedDate = nowDate.toLocaleDateString();
  const formattedTime = nowDate.toLocaleTimeString();

  const headers = Object.keys(postList[0] || {});
  var [partdetailedList, setPartdetailedList] = useState([]);
  const [showDiv, setShowDiv] = useState(false);
  const [showUpholstery, setshowUpholstery] = useState(false);

  // ✅ HIDDEN PO STATE: Store PO numbers but hide them initially
  const [hiddenPO, setHiddenPO] = useState(true);

  // Tooltip state
  const [tip, setTip] = useState({ show: false, text: "", x: 0, y: 0 });

  const showTip = (e, text) => {
    if (!text) return;

    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const padding = 14;

    let x = e.clientX + 16;
    let y = e.clientY - 60;

    x = Math.max(padding, Math.min(x, vw - 380));
    y = Math.max(padding, Math.min(y, vh - 120));

    setTip({ show: true, text: String(text), x, y });
  };

  const moveTip = (e) => {
    setTip(prev => {
      if (!prev.show) return prev;

      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const padding = 14;

      let x = e.clientX + 16;
      let y = e.clientY - 60;

      x = Math.max(padding, Math.min(x, vw - 380));
      y = Math.max(padding, Math.min(y, vh - 120));

      return { ...prev, x, y };
    });
  };

  const hideTip = () => setTip(prev => ({ ...prev, show: false }));

  const Targeted_part_data = (Item_No) => {
    setShowDiv(true);
    Axios.get(`https://` + Host + `/supplies/pivot/getitemdetails`, {
      params: { Item_No, token }
    }).then((data) => {
      setPartdetailedList(data.data);
    });
  };

  const toggleDiv = () => setShowDiv(!showDiv);

  // ✅ TOGGLE FOR SHOWING/HIDING PO NUMBERS
  const toggleUpholstery = () => {
    setshowUpholstery(!showUpholstery);
    setHiddenPO(!hiddenPO);
  };

  const handlePrint = () => {
    const table = document.querySelector('#alldata');
    const printWindow = window.open("", "", "height=600,width=800");
    const img = document.createElement('img');
    img.src = real_l;

    printWindow.document.write(`
      <html>
        <head>
          <title></title>
          <style>
          h1 {
            display: inline-block;
            vertical-align: middle;
            margin: 0;
            text-align: center;
            width: 100%;
            font-family: Arial, sans-serif;
          }
          img {
            display: inline-block;
            height: 50px;
            margin-right: 10px;
          }
          table {
            border: 1px solid black;
            border-collapse: collapse;
            width: 100%;
            font-family: Arial, sans-serif;
          }
          th, td {
            border: 1px solid black;
            padding: 5px;
          }
          tr:nth-child(even) {
            background-color: #f2f2f2;
          }
          .bottom-right {
            position:relative;
            bottom: 10px;
            right: 10px;
            font-family: Arial, sans-serif;
          }
          table tr:last-child td {
            font-weight: bold;
            background-color: lightgrey;
          }
          </style>
        </head>
        <body>
          <h1>${img.outerHTML} </h1>
          <table class="table table-striped">${(table.innerHTML)}</table>
          <p class="bottom-right">Printed By: ${User}</p>
          <p class="bottom-right">Date Created: ${formattedDate + '  ' + formattedTime}</p>
        </body>
      </html>`
    );
    printWindow.document.close();
    printWindow.focus();
  };

  // Remove all-zero columns
  const zeroColumns = headers.filter((header) => {
    const values = postList.map((post) => post[header]);
    return values.every((value) => value === 0);
  });

  const filteredHeaders = headers.filter((header) => !zeroColumns.includes(header));
  const filteredPostList = postList.map((post) => {
    const filteredPost = {};
    Object.entries(post).forEach(([key, value]) => {
      if (!zeroColumns.includes(key)) filteredPost[key] = value;
    });
    return filteredPost;
  });

  return (
    <div>
      <div className='row'>
        <div class="col-8"> </div><div class="col-3">
          <button className="btn btn-primary" onClick={handlePrint}>Print Table</button>
          <button className="btn btn-light" onClick={toggleUpholstery}>
            {showUpholstery ? 'Hide Po No' : 'Show Po No'}
          </button>
        </div> </div>
      <div id="alldata" className='Supply_pivot'>
        <p>
          <table id="tableData" className="table table-hover">
            <thead className="table-dark">
              <tr>
                {filteredHeaders.map((header) => (
                  header === 'PO_No' || header === 'Item_No' || header === 'ETA' || header === 'Supplier' || header === 'Part_attached' || header === 'Item_Description'
                    ? null
                    : <th key={header} className="header_table">{header}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {filteredPostList.map((post) => (
                <tr key={post.PO_No + post.Item_No}>
                  {filteredHeaders.map((header) => (
                    header === 'PO_No' || header === 'Item_No' || header === 'ETA' || header === 'Supplier' || header === 'Part_attached' || header === 'Item_Description'
                      ? null
                      : (
                        <td key={`${post.PO_No}_${header}`}>
                          {header === 'Description' ? (
                            <div className="dtTipWrap">
                              {/* ✅ HIDDEN PO: Only show when toggled */}
                              {!hiddenPO && (
                                <div
                                  className="dtPoBadge"
                                  onMouseEnter={(e) => showTip(e, `PO: ${post.PO_No}`)}
                                  onMouseMove={moveTip}
                                  onMouseLeave={hideTip}
                                >
                                  {post.PO_No}
                                </div>
                              )}

                              <p className="Description">
                                <a
                                  href="#"
                                  className="description_link"
                                  style={{ textDecoration: "none" }}
                                  onClick={(e) => { e.preventDefault(); Targeted_part_data(post.Item_No); }}
                                  onMouseEnter={(e) => showTip(e, `Item: ${post.Item_No}\nDescription: ${post.Description}`)}
                                  onMouseMove={moveTip}
                                  onMouseLeave={hideTip}
                                >
                                  {post.Description}
                                </a>
                              </p>
                            </div>
                          ) : (
                            post[header] === 0 ? '' : post[header]
                          )}
                        </td>
                      )
                  ))}
                </tr>
              ))}

              <tr className="Total">
                {filteredHeaders.map((header) => (
                  header === 'PO_No' || header === 'Item_No' || header === 'ETA' || header === 'Supplier' || header === 'Part_attached' || header === 'Item_Description'
                    ? null
                    : (
                      <td key={`total_${header}`}>
                        {header === 'Description'
                          ? 'Total'
                          : filteredPostList.reduce((sum, post) => sum + parseFloat(post[header] || 0), 0)
                        }
                      </td>
                    )
                ))}
              </tr>
            </tbody>
          </table>
        </p>

        {/* overlay popup */}
        {showDiv ? (
          <div className="overlay">
            <div className="box">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>PO NO</th>
                    <th>ITEM NO</th>
                    <th>ITEM DESCRIPTION</th>
                    <th>SUPPLIER</th>
                    <th>ETA</th>
                    <th>REMAINED PARTS</th>
                    <th>COMMENTS</th>
                  </tr>
                </thead>
                {partdetailedList.map((val, key) => (
                  <tbody key={key}>
                    <tr>
                      <td>{val.PO_No}</td>
                      <td>{val.Item_No}</td>
                      <td>{val.Item_Description}</td>
                      <td>{val.Supplier}</td>
                      <td>{(val.ETA || "").slice(0, 10)}</td>
                      <td>{val.Remained_parts} {val.Unit}</td>
                      <td>{val.COMMENTS}</td>
                    </tr>
                  </tbody>
                ))}
              </table>
              <button type="button" className="form-control form-rounded" onClick={toggleDiv}>Close</button>
            </div>
          </div>
        ) : null}
      </div>

      {/* Fixed tooltip portal */}
      <div
        className={`dtTooltipPortal ${tip.show ? "show" : ""}`}
        style={{ left: tip.x, top: tip.y }}
      >
        <div className="dtTooltipValue">{tip.text}</div>
      </div>


    </div >
  );
}

export default DynamicTable;